export const hasPermission = (permissions, formCode, subMenu = "", type) => {
  // if (subMenu === "Email Alert Configuration") {
  // console.log("permissions", permissions);
  // console.log("formCode", formCode);
  // console.log("subMenu", subMenu);
  // console.log("type", type);
  // }

  if (!permissions) {
    return false;
  }

  if (subMenu === "") {
    const item = permissions?.find((p) => p.formCode === formCode);
    // console.log("item - 0", item);
    return item?.[type] ?? false;
  } else if (subMenu !== "") {
    const item = permissions?.find(
      (p) => p.formCode === formCode && p.subMenu === subMenu
    );

    // if (subMenu === "Master") {
    //   const item2 = permissions?.some((p) => p.subMenu === subMenu && p);

    //   return item2?.[type] ?? false;
    // }
    // console.log("item - 1", formCode, subMenu, item);
    return item?.[type] ?? false;
  }

  const item = permissions?.find(
    (p) => p.formCode === formCode && p.subMenu === subMenu
  );
  // console.log("item - 2", item);
  return item?.[type] ?? false;
};
